import { Modelo } from '@ext/index';
import * as Types from './Mensaje.types';
import moment, { Moment } from 'moment';
import { isArray } from 'util';

export class IMensaje extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: string = '';
    public Chat: number = 0;
    public IdExterna: string = '';
    public Usuario: number = 0;
    public Propio: boolean = false;
    public Contenido: string = '';
    public Fecha: Moment = moment();
    public FechaEnviado: Moment = moment( '' );
    public FechaRecibido: Moment = moment( '' );
    public FechaLeido: Moment = moment( '' );
    public Enviado: boolean = false;
    public Enviando: boolean = false;
    public Recibido: boolean = false;
    public Leido: boolean = false;
    public UsuarioSistema = {
        Nombre: '',
        Apellido: '',
        Usuario: '',
    };

    public Adjuntos: Adjunto[] = [];
    public get Error(): boolean
    {
        return !this.Enviado && !this.Recibido && !this.Enviando && !this.Leido;
    }

    public get Imagenes(): Adjunto[]
    {
        return this.Adjuntos.filter( x => x.esImagen );
    }

    public get Archivos(): Adjunto[]
    {
        return this.Adjuntos.filter( x => !x.esImagen );
    }

    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.chat = this.Chat;
        //json.id_externa = this.IdExterna;
        //json.usuario = this.Usuario;
        //json.propio = this.Propio;
        json.contenido = this.Contenido;
        //json.fecha = this.Fecha.toSQL();
        //json.fecha_enviado = this.FechaEnviado.toSQL();
        //json.fecha_recibido = this.FechaRecibido.toSQL();
        //json.fecha_leido = this.FechaLeido.toSQL();
        //json.enviado = this.Enviado;
        //json.recibido = this.Recibido;
        //json.leido = this.Leido;
        json.adjuntos = this.Adjuntos.map( x => x.getJson() );

        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? '' : this.Json.id;
        this.Chat = !this.Json.chat ? 0 : this.Json.chat;
        this.IdExterna = !this.Json.id_externa ? '' : this.Json.id_externa;
        this.Usuario = !this.Json.usuario ? 0 : this.Json.usuario;

        this.Propio = this.Json.propio == 'S';
        this.Contenido = !this.Json.contenido ? '' : this.Json.contenido;
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );
        this.FechaEnviado = !this.Json.fecha_enviado ? moment( '' ) : moment( this.Json.fecha_enviado );
        this.FechaRecibido = !this.Json.fecha_recibido ? moment( '' ) : moment( this.Json.fecha_recibido );
        this.FechaLeido = !this.Json.fecha_leido ? moment( '' ) : moment( this.Json.fecha_leido );
        this.Enviado = this.Json.enviado == 'S';
        this.Recibido = this.Json.recibido == 'S';
        this.Leido = this.Json.leido == 'S';
        this.Enviando = false;



        if ( this.Propio && this.Json.usuario && this.Json.usuario.nombre )
        {
            this.UsuarioSistema.Nombre = this.Json.usuario.nombre;
            this.UsuarioSistema.Apellido = this.Json.usuario.apellido;
            this.UsuarioSistema.Usuario = this.Json.usuario.usuario;
        }


        this.Adjuntos.clear();
        if ( this.Json.adjuntos && isArray( this.Json.adjuntos ) && this.Json.adjuntos.hasRows() )
        {
            this.Adjuntos.push( ... this.Json.adjuntos.map( ( x: any ) => new Adjunto( x ) ) );
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IMensaje )
    {
        this.Model = Model;
    }

    public Model: IMensaje;
}


export class Adjunto extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public IdProvisional: string;
    public Mensaje: string = '';
    public Tipo: string = '';
    public Nombre: string = '';
    public Archivo: string = '';
    public ArchivoProvisional: string = null;
    public ArchivoEstatico: string = null;
    public URLProvisional: string = null;

    public get URL()
    {
        if ( this.Archivo.startsWith( 'http://' ) || this.Archivo.startsWith( 'https://' ) )
            return this.Archivo;
        else
            return this.URLProvisional;
    }

    public get esImagen()
    {
        return this.Tipo.includes( 'png' ) ||
            this.Tipo.includes( 'image' ) ||
            this.Tipo.includes( 'bmp' ) ||
            this.Tipo.includes( 'jpg' ) ||
            this.Tipo.includes( 'jpeg' );
    }

    public get esInvalido()
    {
        return this.Tipo.includes( 'octet-stream' );

    }

    public getJson(): any
    {
        let json: any = {};

        //json.mensaje = this.Mensaje;
        json.tipo = this.Tipo;
        json.nombre = this.Nombre;
        json.archivo = this.ArchivoProvisional;
        json.archivo_estatico = this.ArchivoEstatico;
        return json;
    }

    public set(): boolean
    {
        this.Id = !this.Json.id ? '' : this.Json.id;
        this.Mensaje = !this.Json.mensaje ? '' : this.Json.mensaje;
        this.Tipo = !this.Json.tipo ? '' : this.Json.tipo;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.Archivo = !this.Json.archivo ? '' : this.Json.archivo;

        this.Existe = true;
        return this.Existe;
    }
}